import { GTM_PAGEVIEW_EVENT_NAME } from '@/constants/global';
import { setUserDataLayer } from '../util/global';

export default function (ctx) {
  let isFirstLoad = true;

  ctx.app.router.beforeEach((_, __, next) => {
    if (isFirstLoad) {
      next();
      return;
    }

    ctx.$gtm.push(function reset() {
      this.reset();
    });
    next();
  });

  ctx.app.router.afterEach((to) => {
    /**
     * Do not track pageviews when nuxt loads the very first time to avoid
     * duplicated records on GA, this is happening because we're initializing
     * manually gtm on the base layout.
     *
     * TODO: We should remove this flag when all pages are already migrated to
     * Nuxt and if we use the autoinit gtm flag, also we should update the
     * `Pro - GA - Pageview` GTM tag that tracks the pageviews and use only the
     * `pageview` custom event for nuxt, then we should remove the generic GA
     * trigger (All Pages).
     *
     * TODO: Use runtimeconfig to setup gtm module.
     */
    if (isFirstLoad) {
      isFirstLoad = false;
      return;
    }

    const { $gtm, store } = ctx;
    const { user } = store.state.session;
    const urlData = new URL(window.location.href);
    const pageUrl = urlData.pathname + urlData.search;

    // Set datalayer for user info
    setUserDataLayer(user, $gtm);

    // Inside a timeout to get the current page title.
    setTimeout(() => {
      $gtm.push({
        event: GTM_PAGEVIEW_EVENT_NAME,
        pageType: 'PageView',
        pageUrl,
        pageTitle: document.title,
        routeName: to.name || '',
      });
    }, 250);

    store.dispatch('experiments/enroll');
  });
}
